import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUiModal } from "../context/UiModalContext";

export default function TicketsNewRoute() {
  const navigate = useNavigate();
  const { openNewTicketModal } = useUiModal();

  useEffect(() => {
    openNewTicketModal({ defaultDate: new Date() });
    navigate("/tickets", { replace: true });
  }, [navigate, openNewTicketModal]);

  return null;
}
